import { render, staticRenderFns } from "./ExpenseRequestBlockFormBox.vue?vue&type=template&id=78043fe9"
import script from "./ExpenseRequestBlockFormBox.vue?vue&type=script&lang=js"
export * from "./ExpenseRequestBlockFormBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports